import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DisclaimerLinksComponent} from './disclaimer-links/disclaimer-links.component';
import {RouterModule} from '@angular/router';
import {UsageHintsComponent} from "./usage-hints/usage-hints.component";
import {UsageHintsModalComponent} from "./usage-hints-modal/usage-hints-modal.component";
import {MatIconModule} from "@angular/material/icon";
import {MatStepperModule} from "@angular/material/stepper";
import {MatDialogModule} from "@angular/material/dialog";
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {TermsOfUseComponent} from "./legal/terms-of-use/terms-of-use.component";
import {AboutUsComponent} from "./legal/about-us/about-us.component";
import {ContactUsComponent} from "./legal/contact-us/contact-us.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SrsDisclaimerComponent} from "./legal/srs-disclaimer/srs-disclaimer.component";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";

import {MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SharedModule} from "../shared/shared.module";


@NgModule({
  declarations: [

    DisclaimerLinksComponent,
    UsageHintsComponent,
    UsageHintsModalComponent,
    AboutUsComponent,
    ContactUsComponent,
    TermsOfUseComponent,
    SrsDisclaimerComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    MatIconModule,
    MatStepperModule,
    MatDialogModule,
    MatMenuModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    FormsModule
  ],
  exports: [
    UsageHintsComponent
  ]
})
export class LayoutModule {
}
